import React, { useEffect, useState } from "react";
import HashLoader from "react-spinners/HashLoader";
// import Iframe from 'react-iframe'
import { useParams } from "react-router";

const InfoVotante = () => {
  const { id } = useParams();

  const tabla = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/lider.php?id=${id}`
      );
      const dato = await res.json();
     
      setdatosJson(dato[0]);

      setLoading(false);
    } catch (error) {
      // window.location = "/404";
    }
  };
  useEffect(() => {
    tabla();
    localStorage.removeItem("id_");
    localStorage.removeItem("CARRITO");
    // eslint-disable-next-line
  }, []);

  const [loading, setLoading] = useState(true);
  const [datosJson, setdatosJson] = useState({});


  return (
    <>
      {loading ? (
        <div className="carga">
          <HashLoader color={"#D0021B"} loading={loading} size={80} />
        </div>
      ) : (
        <>
          <div className="container">
            <div
              style={{ marginBottom: "10em", marginTop: "6em" }}
              className="row  "
            >
              <div style={{ borderRight: "2px dotted" }} className="col-6">
                {/* <img className="mt-5" width="100%" alt="..." /> */}
                <h4>Lider</h4>
                <h5 className="text-muted mt-3">
                  Resumen De la Informacion de lider
                </h5>

                <h4 className="text-muted mt-4"> </h4>
                <h4>
                  {datosJson.nombreLider} {datosJson.apellidoLider}
                </h4>

                <h4 className="text-muted mt-4"> Mesa </h4>
                <h6>{datosJson.mesaLider} </h6>
                <h4 className="text-muted mt-4">Telefono </h4>
                <h6>{datosJson.telefonoLider} </h6>
                <h4 className="text-muted mt-4">Cedula </h4>
                <h6>{datosJson.cedulaLider} </h6>
                <h4 className="text-muted mt-4">Lugar de votacion </h4>
                <h6>{datosJson.lugarVotacionLider} </h6>


                {/* <Iframe url="https://wsp.registraduria.gov.co/censo/consultar/"
            
            width="100%"
            id="myId"
            className="mt-4"
            height="100%"
            /> */}
              </div>
              <div className="col-6">
                <div className="row">
                  <div
                    style={{ textAlign: "center", borderBottom: "2px dotted" }}
                    className="col-12  "
                  >
                    <h6>
                      {datosJson.nombre} {datosJson.apellido}{" "}
                    </h6>

                    <div
                      style={{ padding: "2px", borderRadius: "40px" }}
                      className="alert alert-success"
                      role="alert"
                    >
                      <h6>{datosJson.fechaCreacion}</h6>
                    </div>
                  </div>
                  <div className="col-12">
                    <h4 className="text-muted mt-4"> Telefono </h4>
                    <h6>{datosJson.Telefono}</h6>
                    <h4 className="text-muted mt-4"> Cedula </h4>
                    <h6>{datosJson.cedula}</h6>
                    <h4 className="text-muted mt-4">Mesa </h4>
                    <h6>{datosJson.mesa}</h6>
                    <h4 className="text-muted mt-4">Barrio de residencia</h4>
                    <h6>{datosJson.barrioResidencia}</h6>
                    <h4 className="text-muted mt-4">Comunidad</h4>
                    <h6>{datosJson.comunidad}</h6>
                    <h4 className="text-muted mt-4">Telefono responsable</h4>
                    <h6>{datosJson.TelefonoResponsable}</h6>
                    <h4 className="text-muted mt-4">Perfil profesional</h4>
                    <h6>{datosJson.perfilProfesional}</h6>
                    <h4 className="text-muted mt-4">Compromiso</h4>
                    <h6>{datosJson.compromiso}</h6>

                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default InfoVotante;
